import actionCreatorFactory from 'typescript-fsa';
import { InferenceResult } from '../../../models/InferenceResult';
import { InferenceAdditionalResult } from '../../../models/InferenceAdditionalResult';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('inference');

const execute = actionCreator.async<
  {
    imageStr: string
  }, // started: parameter type
  {
    results: InferenceResult[];
    additionalResult: InferenceAdditionalResult;
    croppedImage: {
      bucket: string;
      key: string;
    }
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('EXECUTE');

const reset = actionCreator('RESET');

export {
  execute,
  reset
};



// WEBPACK FOOTER //
// ./src/redux/modules/inference/actions.ts